import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { RateType } from '../shared/types/rate-shop-types';

interface RateTypeSelectorProps {
  value: RateType;
  onValueChange: (value: RateType) => void;
  className?: string;
}

export const RateTypeSelector = ({
  value,
  onValueChange,
  className = 'w-[180px]',
}: RateTypeSelectorProps) => {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value='lowest'>Lowest Rate</SelectItem>
        <SelectItem value='best-flex'>Best Flex Rate</SelectItem>
      </SelectContent>
    </Select>
  );
};
